const PROGRAM_SELECT_ID = "ProgramHome";
const HINT_SELECTOR = ".form__field-hint";
const HINT_VISIBLE_CLASS = "form__field-hint--visible";

function getProgramSelect() {
  return document.getElementById(PROGRAM_SELECT_ID);
}

function getHint(programSelect = getProgramSelect()) {
  return (
    programSelect?.closest(".form__field_program")?.querySelector(HINT_SELECTOR) ||
    null
  );
}

function showProgramRegionHint() {
  const hint = getHint();

  if (!hint) return;

  hint.classList.add(HINT_VISIBLE_CLASS);

  /* Подсказка о выборе региона важнее ошибки валидации формы — не даём им наложиться */
  hint
    .closest(".form__field_program")
    ?.querySelector(".form__error-container")
    ?.remove();
}

function hideProgramRegionHint() {
  getHint()?.classList.remove(HINT_VISIBLE_CLASS);
}

/* Поле "Программа" неактивно, пока не выбран регион (главная страница) */
function disableProgramField() {
  const select = getProgramSelect();

  if (!select) return;

  select.disabled = true;
  $(select).trigger("change");
  showProgramRegionHint();
}

function enableProgramField() {
  const select = getProgramSelect();

  if (!select) return;

  select.disabled = false;
  $(select).trigger("change");
  hideProgramRegionHint();
}

/* Подсказка видна сразу, пока поле неактивно — синхронизируем на случай,
   если вёрстка изначально не проставила класс видимости */
function setupProgramFieldHint() {
  const select = getProgramSelect();

  if (!select) return;

  if (select.disabled) {
    showProgramRegionHint();
  } else {
    hideProgramRegionHint();
  }
}

export {
  setupProgramFieldHint,
  showProgramRegionHint,
  hideProgramRegionHint,
  disableProgramField,
  enableProgramField,
};
